import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ProveedorService } from 'src/app/services/proveedor.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarProveedorComponent } from '../../shared/modal-seleccionar-proveedor/modal-seleccionar-proveedor.component';
import { ConsultarPagosProveedorModalViewDetailsComponent } from '../consultar-pagos-proveedores/modal-view-details/modal-view-details.component';

@Component({
  selector: 'app-cartola-proveedores',
  templateUrl: './cartola-proveedores.component.html',
  styleUrls: ['./cartola-proveedores.component.scss'],
  providers: [SecurityService],
})
export class CartolaProveedorComponent implements OnInit {
  // Modales
  @ViewChild(ConsultarPagosProveedorModalViewDetailsComponent, { static: true }) modalVerPago: ConsultarPagosProveedorModalViewDetailsComponent;
  @ViewChild(ModalSeleccionarProveedorComponent, { static: true }) modalSeleccionarProveedor: ModalSeleccionarProveedorComponent
  @Output() onProveedorChange: EventEmitter<any> = new EventEmitter<any>()

  // Form
  formHeader: FormGroup

  // Data &  Tmp
  private rutEmpresa: Number
  private sucursalEmpresa: Number
  private inputParams: any = null
  proveedorSeleccionado: any = null
  listaRegistros: any = null
  totales: any = null
  paginationContext: PaginationContext = new PaginationContext()
  loading: boolean = false
  loaded: boolean = false
  headerData: any = {}

  // Utils
  private log: any

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private rutService: RutService,
    private clog: ConsoleService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private fileDownloadService: FileDownloadService,
    private ProveedorService: ProveedorService,
    private datesService: DatesService,
    private formValidatorsService: FormValidatorsService,
  ) {
    this.log = this.clog.log('CARTOLA-PORVEEDOR')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())
    this.paginationContext.RecordsByPage = 10

    this.createForms()
    this.formChangesSubscriptions()
  }

  private createForms() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader = this.fb.group({
      rut: [null, [Validators.required]],
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]]
    });
  }

  private formChangesSubscriptions() {
    this.formHeader.get("rut").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rut: string) => {
        this.modalSeleccionarProveedor.searchByRut(rut)
      })
  }

  abrirModalSeleccionarProveedor() {
    this.modalSeleccionarProveedor.show()
  }

  onProveedorSeleccionado({ data, origen }) {
    this.proveedorSeleccionado = data
    this.proveedorSeleccionado.rutFormato = this.rutService.AgregarDV(this.proveedorSeleccionado.rut)
    this.formHeader.get('rut').setValue(this.proveedorSeleccionado.rutFormato)
    this.onProveedorChange.emit(this.headerData.proveedorSeleccionado)
  }

  onProveedorNoEncontrado() {
    this.proveedorSeleccionado = null
    this.clearProveeData()
  }
  clearProveeData() {
    this.clearContent()
    this.onProveedorChange.emit(null)
  }

  clearContent(){
    this.headerData = {}
  }

  validateAllFormFields(formGroup: FormGroup) {         // {1}
    Object.keys(formGroup.controls).forEach(field => {  // {2}
      const control = formGroup.get(field);             // {3}
      if (control instanceof FormControl) {             // {4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        // {5}
        this.validateAllFormFields(control);            // {6}
      }
    });
  }

  onPageChange(context: PaginationContext) {
    this.paginationContext.CurrentPage = context.RequestedPage
    this.buscar()
  }

  buscar(fromStartPage: Boolean = false) {
    if (fromStartPage) {
      this.validateAllFormFields(this.formHeader);
      if (!this.formHeader.valid) {
        this.toastrService.warning('Favor complete los datos requeridos');
        return
      }

      this.paginationContext.CurrentPage = 1
      this.listaRegistros = null
    }

    const inputParams = {
      entidad: {
        empresa_rut: Number(this.rutEmpresa),
        sucursal_codigo: Number(this.sucursalEmpresa),
        cliente_proveedor_rut: this.proveedorSeleccionado == null ? 0 : this.proveedorSeleccionado.rut,
        fecha_desde: this.formHeader.get('fechaDesde').value,
        fecha_hasta: this.formHeader.get('fechaHasta').value,
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }

    this.loaded = false
    this.loading = true

    this.inputParams = inputParams

    this.loading = true
    this.ProveedorService.getCartolaProveedor(inputParams, ({ mensajesDetalles, respuestaDetalles, mensajesTotales, respuestaTotales }) => {
      let ok = respuestaDetalles !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajesDetalles)
        this.handleSearchError()
        return
      }

      ok = respuestaTotales !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajesTotales)
        this.handleSearchError()
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuestaDetalles
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas
      this.listaRegistros = registros

      this.totales = respuestaTotales

      //this.GetAbonosPorAplicar()
      this.loading = false
    })
  }

  handleSearchError() {
    this.loaded = true
    this.loading = false
  }

  downloadExcel() {
    const inputParams = _.cloneDeep(this.inputParams)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual
    inputParams.entidad.retornaExcel = true;

    this.ProveedorService.getCartolaProveedorExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }

  loadAndShowDetallePago({ pago_codigo, cliente_proveedor_rut }) {
    this.modalVerPago.loadAndShow(pago_codigo, cliente_proveedor_rut);
  }
}
